import { matchPath } from 'react-router';

import { isApplicationNonProd } from 'Utilities/helpers';
import routing from 'Utilities/routing';
import { User } from 'Utilities/user/@types';

const BASE_URL = isApplicationNonProd
  ? 'https://motorway-stage.onelink.me/tpQp'
  : 'https://motorway.onelink.me/gYoi';

const BASE_CTA_LINK = `${BASE_URL}?af_xp=custom&pid=sliplane&c=deferred_link&is_retargeting=true&af_reengagement_window=lifetime`;

const buildDeepLink = (url: string) =>
  `${BASE_CTA_LINK}&deep_link_value=${encodeURIComponent(url)}`;

type GetCTAHrefParams = {
  loginToken?: User['login_token'];
  pathname: string;
  sliplaneUrl?: string;
};

export const getButtonLink = ({ loginToken, pathname, sliplaneUrl }: GetCTAHrefParams) => {
  if (!sliplaneUrl) {
    return BASE_CTA_LINK;
  }

  if (!loginToken) {
    return buildDeepLink(sliplaneUrl);
  }

  const params = new URLSearchParams({ token: loginToken });
  const vrmMatch = matchPath<{ vrm: string }>(pathname, { path: routing.vrmPath });

  if (vrmMatch?.params?.vrm) {
    params.set('vrm', vrmMatch.params.vrm.toUpperCase());
  }

  return buildDeepLink(`${sliplaneUrl}?${params}`);
};
